import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Typography from 'components/Typography'

import classes from './DeltaChange.module.scss'

/** @type {import('./types').default} */
const DeltaChange = ({ listingRating, alternativeRating, className }) => {
  const value = alternativeRating - listingRating

  const formattedValue = Math.abs(value).toFixed(1)

  return (
    <div
      className={clsx('DeltaChange', className, classes.container, {
        [classes.negative]: value < 0,
        [classes.positive]: value > 0,
      })}
    >
      {!!value && (
        <>
          <Icon icon={value > 0 ? 'caret-up' : 'caret-down'} />
          <Typography variant="tight-xs">{formattedValue}</Typography>
        </>
      )}
    </div>
  )
}

export default DeltaChange
